<template>
  <main>
    <Header />
    <div class="d-flex justify-content-center">
      <div class="main-content col-lg-10">
        <h3 class="text-normal mb-3 text-left font-bold">Find Us</h3>
        <img src="../assets/map.png" class="img-fluid" alt="Map Location fo RevolutionPlus Property Office">
        <ContactFooter />
      </div>
    </div>
    <SocialLinks />
  </main>
</template>

<script>
import Header from '../components/common/Header'
import ContactFooter from '../components/common/ContactFooter'
import SocialLinks from '../components/common/SocialLinks'

export default {
  name: "Contact",
  metaInfo: {
    title: 'Contact Us',
  },
  components: {
    Header,
    ContactFooter,
    SocialLinks
  },
}
</script>

<style scoped>
.main-content {
  padding: 20px;
  background-color: #fff;
  margin-bottom: 0;
}
@media (min-width: 1200px) {
  .main-content {
    padding: 40px;
  }
}
</style>
